import { render, staticRenderFns } from "./LamboProcessExcellenceColumn.vue?vue&type=template&id=c55471d6&"
import script from "./LamboProcessExcellenceColumn.vue?vue&type=script&lang=js&"
export * from "./LamboProcessExcellenceColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports